import useControl from "@/hooks/useControl";
import { Dialog3, Dialog4 } from "./dialogs";
import { css, cx } from "@styled-system/css";
import { button } from "@styled-system/recipes";
import BarkioBanner1 from "@/assets/barkio/sep-anxiety/BarkioBanner1.jpg";
import BarkioBanner2 from "@/assets/barkio/sep-anxiety/BarkioBanner2.jpg";
import WaitingDog from "@/assets/barkio/sep-anxiety/WaitingDog.jpg";
import SadDog from "@/assets/barkio/sep-anxiety/SadDog.jpg";
import DigFence from "@/assets/barkio/sep-anxiety/DigFence.jpg";
import SmilingDog from "@/assets/barkio/sep-anxiety/SmilingDog.jpg";
import SadDogBowl from "@/assets/barkio/sep-anxiety/SadDogBowl.jpg";
import DogPhotoShoot from "@/assets/barkio/sep-anxiety/DogPhotoshoot.jpg";
import LeavingDog from "@/assets/barkio/sep-anxiety/LeavingTheDog.jpg";
import DogMonitoring from "@/assets/barkio/sep-anxiety/DogMonitoring.jpg";
import Infographic from "@/assets/barkio/sep-anxiety/infoGraphic.jpg";
import TT1 from "@/assets/barkio/sep-anxiety/TT1.jpg";
import TT2 from "@/assets/barkio/sep-anxiety/TT2.png";

export const listItems = [
  "what-is-separation-anxiety",
  "how-does-fear-originate",
  "anxiety-symptoms",
  "differential-diagnoses",
  "what-to-watch",
  "diagnostics",
  "treatment",
  "patient-monitoring",
  "prevention",
  "prognosis",
  "stories",
  "about-us"
];

export default function Data() {
  const dialog3 = useControl();
  const dialog4 = useControl();

  return (
    <div>
      <Dialog3 isOpen={dialog3.isOpen} onClose={dialog3.close} />
      <Dialog4 isOpen={dialog4.isOpen} onClose={dialog4.close} />
      <div>
        <div id="what-is-separation-anxiety" className="chapter-wrap">
          <div className="chapter-number">01 </div>
          <h3>Co je separační úzkost?</h3>
        </div>
        <p>
          Separační úzkost je stav tísně a strachu, který pociťuje pes, když osoba, ke které má pevnou vazbu, odejde
          nebo se k odchodu chystá. Je to nejčastější problém, co trápí psy a jejich majitele po celém světě. Může
          vzniknout u obou pohlaví a jakéhokoliv plemene včetně kříženců. Nejvíc jsou jím postiženi mladí psi ve věku do
          3 let (asi 60%), ve středním věku výskyt problému klesá. Objevuje se ale znovu kolem 8 let. To pravděpodobně
          souvisí s dalšími úzkostnými poruchami, které jsou spojeny s vyšším věkem.
        </p>
        <a href="/">
          <img src={BarkioBanner1.src} alt="Barkio app" className="article-image banner" />
        </a>
        <h4 id="reasons">Příčiny vzniku</h4>
        <p>
          Pes je silně sociálním zvířetem, které ke spokojenému životu potřebuje společnost dalších sociálních partnerů.
          Samota u většiny psů vyvolává strach, úzkost a nejistotu.
        </p>
        <p>
          Obvykle ji dobře snášejí jedinci s odolnou nervovou soustavou, kteří jsou na pobyt o samotě postupně
          přivykáni, mají dostatek sociálních kontaktů s jinými psy i s lidmi mimo rodinu, nejsou přetěžováni příliš
          dlouhým odloučením a v době, kdy byli sami, nezažili žádnou dramatickou ani strach nahánějící událost (třeba
          bouřku, ohňostroj nebo velký hluk v domě).
        </p>
        <p>
          Velmi těžko si na samotu naopak zvykají štěňata starší 16 týdnů, která dosud žila s matkou nebo s dalšími
          sourozenci, a také dospělí psi odebraní ze smečky. Rizikovou skupinou jsou i nalezenci a psi, kteří přišli z
          útulku nebo z krutých podmínek. Takoví nešťastníci k novému majiteli přilnou opravdu silně, znamená pro ně
          totiž záruku bezpečí. I kratičká samota nebo pouhý náznak toho, že odchází, u nich vyvolá panickou reakci.
          Separační úzkostí jsou ohroženi také psi s labilní nervovou soustavou a se sklony k dalším strachům nebo
          fobiím (tyto sklony jsou obvykle dědičné).
        </p>
        <div className="custom-quotation">
          <div className="custom-line col-lg-3"></div>
          <p>
            „Separační úzkost je nejčastějším problémem, který trápí psy a jejich majitele po celém světě. Může
            vzniknout u obou pohlaví a jakéhokoliv plemene včetně kříženců.“
          </p>
        </div>
        <img src={WaitingDog.src} alt="Dog waiting" className="article-image" />
        <p>
          Na vzniku separační úzkosti se podílí mnoho faktorů. Mezi ty nejrizikovější, které vedou k jejímu vzniku u
          psů, patří tyto:
        </p>
        <h5 id="single">Majitel žije se psem sám</h5>
        <p>
          S tímto fenoménem souvisí přetěžování psa dlouhou samotou v době, kdy je jeho majitel dlouho (8 a více hodin)
          v práci, nebo nedostatečný či žádný návyk na samotu u psů, kteří žijí ve společnosti starého člověka, co je
          opouští jen velmi výjimečně (třeba jen kvůli návštěvě lékaře, nákupu a podobně).
        </p>
        <h5 id="void">V blízkosti není štěněcí školka ani dobré cvičiště</h5>
        <p>
          Psi, kteří nejsou zvyklí s majitelem „pracovat“ - tedy plnit jeho pokyny a toužit po odměně a uznání - mívají
          s nácvikem samoty problém.
        </p>
        <h5 id="hotel">Pobyty ve psích hotelech</h5>
        <p>
          Separační úzkost se u psa může rozvinout i v době, kdy pobývá v neznámém prostředí psího hotelu nebo podobného
          zařízení, když se o něj majitel dočasně nemůže postarat.
        </p>
        <h5 id="scare">Pes zažije děsivou situaci</h5>
        <p>
          Spouštěcím momentem může být situace, kdy pes zažije něco děsivého v době, kdy je sám doma - třeba intenzivní
          bouřku, průvan a rozbité okno, vloupání zlodějů nebo chaotickou a hlučnou rekonstrukci domu nebo sousedního
          bytu, při které se také setkává s úplně cizími lidmi.
        </p>
        <h5 id="puppy">Odchov štěňat</h5>
        <p>
          Velmi rizikový je odchov štěňat v nevhodných podmínkách - například v kůlně, chlívku, garáži, samostatné
          místnosti nebo v kotci - kde jim chybí vnější podněty. Takto odchovaní psi bývají přecitlivělí na jakýkoliv
          stres, samotu nevyjímaje, a při jejich bázlivosti se s nimi samota těžko nacvičuje.
        </p>
        <div id="how-does-fear-originate" className="chapter-wrap">
          <div className="chapter-number">02 </div>
          <h3>Jak vzniká strach?</h3>
        </div>
        <p>
          Hlavním orgánem, ve kterém – kromě dalších emocí – vzniká i strach, je nervové jádro amygdala. Nachází se pod
          spánkovým lalokem velkého mozku a všechny informace o podnětu a případných zkušenostech s ním se soustředí
          právě v něm. Na podnět reaguje tím, že vyšle signál na tři místa: Do šedé mozkové kůry, která řídí aktivitu
          kosterní a svalové soustavy, dále do části hypotalamu, která řídí aktivitu autonomního nervového systému, a i
          do části hypotalamu, která má na starosti hormonální funkce. Spustí se blesková reakce celého organismu, která
          má za úkol zachránit život. Vystihuje ji anglické spojení <span className="bold">„Fight, or flight!“</span>{" "}
          (tedy: Bojuj, nebo uteč!). Zvýší se dechová a tepová frekvence, srdeční výkon a průtok krve k životně
          důležitým orgánům (mozek, svaly). Hormonální odpověď zahrnuje i uvolnění vlny kortizolu, což významně
          ovlivňuje metabolismus glukózy a další důležité metabolické procesy. Organismus mobilizuje rychlé zdroje
          energie.
        </p>
        <p>
          V daném okamžiku jsou tyto změny pozitivní, protože zvířeti umožní před stimulem, který ho ohrožuje, buď
          utéct, nebo s ním aktivně bojovat. Když ale zvíře nemůže utéct a ani se tomuto podnětu jinak vyhnout, vzniká
          chronická stresová reakce, která může skončit vážným poškozením organismu a někdy dokonce smrtí.
        </p>
        <img src={SadDog.src} alt="Sad Dog" className="article-image" />
        <p>
          Charakter odpovědi na strachový podnět závisí na mnoha vlivech. Roli hrají faktory genetické (vrozené) a
          empirické (získané zkušeností). Ve většině případů zvíře reaguje na podnět, který ho v daném okamžiku nějak
          ohrožuje, normálně. Za abnormální považujeme, když je odpověď na strachový podnět nepřiměřená nebo dokonce
          nesmyslná. Tehdy může dojít až k dysregulaci, tedy ke ztrátě kontroly nad odpovědí na takový podnět. To se
          může projevit na různých úrovních, kromě jiného také na neurotransmiterové aktivitě.
        </p>
        <div className="space-left">
          <div className="quoteline-side">
            <div className="custom-quotation2">
              <p>
                <span className="color-quote">Neurotransmitery </span>jsou chemické látky, které přenášejí signály a
                informace mezi nervovými buňkami. Nejdůležitějšími neurotransmitery, které se na strachové odpovědi
                podílejí, jsou hlavně serotonin, noradrenalin a kyselina gamaaminomáselná (GABA). Proto se léčba poruch,
                co souvisejí se strachem, zaměřuje na ovlivnění těchto neurotransmiterů.
              </p>
            </div>
          </div>
        </div>
        <div id="anxiety-symptoms" className="chapter-wrap">
          <div className="chapter-number">03 </div>
          <h3>Projevy separační úzkosti</h3>
        </div>
        <p>
          Způsobů, kterými se separační úzkost projevuje, může být celá řada. Pro majitele je důležité hlavně to, aby si
          uvědomili, že pes, který touto úzkostí trpí, se jim v žádném případě nesnaží záměrně škodit nebo mstít -
          ačkoliv si to v drtivé většině případů bohužel myslí.
        </p>
        <h5>Ničení zařízení v bytě</h5>
        <p>
          Pes nejčastěji ničí předměty, které úzce souvisí s blízkou osobou – postel, pohovku, knihy, tašky, kabelky,
          boty, oblečení a předměty na kuchyňské lince. Často ničí hrabáním zdi a podlahy kolem dveří a oken.
        </p>
        <h5>Pokusy o útěk</h5>
        <p>
          Pes se vytrvale snaží utéct, a tak škrábe a kouše dveře a okenní rámy, snaží se podhrabat pod plotem nebo se
          protáhnout větračkou, překousat drátěné pletivo. Okusuje a ohýbá mříže v kotci nebo v kleci, přeskakuje a
          přelézá vysoké ploty a zdi nebo proskakuje zavřeným oknem. Při těchto zoufalých aktivitách se často vážně
          poraní.
        </p>
        <img src={DigFence.src} alt="Dog escaping" className="article-image" />
        <h5>Štěkání a vytí</h5>
        <p>
          To obvykle začíná hned, jak se pes přesvědčí, že majitel skutečně odešel. Signálem je třeba zaklapnutí
          domovních dveří nebo odjíždějící auto. S malými přestávkami, během kterých pes poslouchá, jestli se majitel
          nevrací, může štěkat a výt dokonce i mnoho hodin. Často se to děje po celou dobu, co je pes samotný.
        </p>
        <div className="custom-quotation">
          <div className="custom-line col-lg-3"></div>
          <p>
            „Nejde o žádné ‚naschvály‘, jak tomu často říkají rozčílení majitelé, ale o důsledek velkého strachu a
            reakcí organismu, které pes vůlí nedokáže ovládnout.“
          </p>
        </div>
        <h5>Impulzivní vyměšování</h5>
        <p>
          S nástupem strachu se okamžitě zrychluje psí metabolismus a močový měchýř i konečník se za velmi krátkou dobu
          – třeba i během několika minut – naplní. Dráždivost stěny močového měchýře vůči náplni vzroste, a tak pes cítí
          nutkání močit i tehdy, kdy měchýř vlastně není plný. Kvůli strachu navíc povoluje tonus svěračů, takže pes
          nedokáže udržet moč ani stolici stejně dobře, jako když je klidný, a musí se okamžitě vyprázdnit na místě, kde
          právě je. Nejde tedy o žádné „naschvály“, jak tomu často říkají rozčílení majitelé, ale o důsledek velkého
          strachu a reakcí organismu, které pes vůlí nedokáže ovládnout.
        </p>
        <h5>Silné slinění</h5>
        <p>
          Že pes hodně slintá taktéž souvisí s reakcí organismu na obrovský strach a úzkost. Někdy může slinit až tolik,
          že je celý mokrý a podlaha v bytě dokonce klouže.
        </p>
        <h5>Zrychlené a ztížené dýchání</h5>
        <p>
          Tento příznak souvisí se zmíněnou strachovou reakcí organismu. Pes má otevřenou tlamu, vyplazený jazyk, dýchá
          velice rychle, hlasitě a někdy se dokonce až zalyká. Pokud je v takovém stavu déle, může to vést až k
          naprostému vyčerpání.
        </p>
        <h5>Nechutenství</h5>
        <p>
          Když je sám, pes nejí ani nepije. Jakmile ale majitel přijde, hltavě se na všechno vrhne. Po tom, co se tak
          rychle nají, mnohdy zvrací.
        </p>
        <h5>Stereotypní pohybové aktivity</h5>
        <p>
          Pes běhá v kruhu, sem tam kolem plotu nebo od jedněch dveří ke druhým, aniž by k tomu měl nějaký konkrétní
          důvod. Takové chování vede k tomu, že se unaví nebo dokonce vyčerpá.
        </p>
        <h5>Sebepoškozování</h5>
        <p>
          Pes se může poranit, když se snaží utéct z bytu nebo kotce. Často se objevuje i nutkavé (kompulzivní) chování,
          kdy si pes pod vlivem stresu začne olizovat tlapky a vydrží to dělat i dlouhé hodiny. Brzy se na postižených
          místech začnou objevovat zanícené rány, které pronikají do svaloviny nebo dokonce až ke kosti. Taková poranění
          se velice těžko hojí, a to především proto, že si pes ve stresu rány znovu a znovu rozedírá.
        </p>
        <h5>Pronásledování blízké osoby na každém kroku</h5>
        <p>
          Pes prožívá obrovskou úzkost z toho, že mu majitel opět odejde, a proto se ho bojí ztratit z dohledu i jen na
          moment. Chodí za ním po bytě a nervózně sleduje, jestli se náhodou opět nechystá jít pryč. Nedokáže se uvolnit
          a odpočívat, což ho vyčerpává a unavuje.
        </p>
        <h5>Známky úzkosti, když se majitel chystá k odchodu</h5>
        <p>
          Jakmile pes zpozoruje první známky toho, že se majitel chystá odejít, začne se třást, zrychleně dýchat a
          slinit, odmítá jít do pelíšku a nemá ani chuť na pamlsek. Někteří psi jsou při odchodu majitele agresivní,
          dorážejí na něj a nechtějí ho pustit ze dveří nebo z branky ven.
        </p>
        <h5>Nečinnost a ukrývání</h5>
        <p>
          Vyděšený pes se někdy snaží schovat, a to z toho důvodu, aby se vyhnul určité aktivitě - například ranní
          procházce - po které následuje majitelův odchod. Někteří psi se snaží schovat venku pod zaparkovaným autem
          nebo na těžko přístupném místě, případně se prostě nenechají chytit, když je majitel před odchodem pustí
          proběhnout. Jindy se pes před odchodem majitele schová do pelíšku, ztuhne a přestane komunikovat, protože je
          úplně paralyzovaný strachy.
        </p>
        <h5>Hektické vítání</h5>
        <p>
          Po návratu pes majitele divoce vítá, skáče na něj a přitom dýchá s otevřenou tlamou a vyplazeným jazykem.
          Někdy i naříkavě kňučí. Trvá dlouho, než se docela uklidní. Tak urputně majitele vítá i po jeho docela krátké
          nepřítomnosti.
        </p>
        <img src={SmilingDog.src} alt="Dog smiling" className="article-image" />
        <div className="warning-box">
          <h6>POZOR!</h6>

          <p className="warning-txt">
            Mnoho těchto příznaků nemusí být nutně projevem separační úzkosti. O diferenciálních diagnózách se víc
            dočtete níže.
          </p>
        </div>
        <div id="differential-diagnoses" className="chapter-wrap">
          <div className="chapter-number">04 </div>
          <h3>Diferenciální diagnózy</h3>
        </div>
        <p>
          Tímto výrazem popisujeme další onemocnění a stavy, které mají podobné příznaky jako separační úzkost, ale jde
          o něco jiného a je potřeba je od úzkosti odlišit.
        </p>
        <p>
          Do <span className="bold">ničení zařízení bytu a okusování předmětů</span> se pouštějí zvlášť mladí, aktivní
          psi v rámci hry, dále třeba kvůli bolesti dásní při výměně zubů nebo při onemocnění zubů a dásní.
        </p>
        <p>
          <span className="bold">Pokusy o útěk a škrábání kolem dveří a oken</span> mohou mít hormonální původ (hárání
          fen) nebo může mít pes sklony k toulání. Taky je možné, že je frustrovaný z omezeného prostoru, nebo dokonce
          trpí klaustrofobií.
        </p>
        <p>
          <span className="bold">Vytí, štěkání a kňučení</span> mohou být reakcemi na vnější podněty - třeba na pohyb
          cizích lidí i zvířat na chodbě nebo kolem domu, na hluk způsobený rekonstrukcí sousedního bytu či stavebními
          úpravami v okolí domu. Dál je může způsobit stav, kdy psa něco bolí nebo mu něco vadí (je mu horko, zima, má
          žízeň, hlad, zranil se). Jsou také projevem kognitivní poruchy u starých psů, kteří zapomínají naučené návyky
          a reagují na běžné situace neadekvátně.
        </p>
        <p>
          <span className="bold">Močení a kálení</span> má mnoho důvodů. Často jde o zdravotní problém se zažívacím nebo
          močovým ústrojím, případně o špatně naučenou čistotnost. Příčinou může být i jiný strach, třeba z bouřky či
          střelby, inkontinence, značkování močí a u starých psů může opět jít o kognitivní poruchu.
        </p>
        <p>
          <span className="bold">Silné slinění</span> se může objevit v důsledku požití saponátu, dráždivé či hořké
          látky, nebo dokonce otravy. Na vině může být taktéž onemocnění zubů a dásní.
        </p>
        <p>
          <span className="bold">Zrychlené a namáhavé dýchání</span> může vznikat vlivem hormonů nebo vnějších podnětů.
          Objevuje se v situaci, kdy se pes přehřeje nebo bojuje s onemocněním dýchacího aparátu, oběhovými potížemi či
          celkovým onemocněním (například s infekcí s vysokou horečkou).
        </p>
        <p>
          <span className="bold">Nechutenství</span> je obvykle projevem celkového onemocnění, onemocnění dutiny ústní
          či zažívacího aparátu. Na celkový apetit psa mají velký vliv také pohlavní hormony v době, kdy hárají feny.
          Nechutenství může být způsobeno přílišným horkem nebo jiným strachem či úzkostí.
        </p>
        <img src={SadDogBowl.src} alt="Dog with bowl" className="article-image" />
        <p>
          Příčinou <span className="bold">stereotypních pohybových aktivit</span> psa nemusí být nutně jen separační
          úzkost, může jít o jiný strach či úzkost. Nebo se prostě jen nudí. Důvodem může být i primární psychické
          onemocnění či bolest.
        </p>
        <p>
          <span className="bold">Sebepoškozování</span> může být způsobeno dermatologickým problémem (onemocnění kůže),
          poraněním či alergií. Dalšími příčinami bývá nuda nebo primární psychické onemocnění - kompulzivní porucha.
        </p>
        <div id="what-to-watch" className="chapter-wrap">
          <div className="chapter-number">05 </div>
          <h3>Co je důležité sledovat a proč?</h3>
        </div>
        <p>
          Sledovat chování psa, vědět o jeho netypických projevech a konzultovat je s veterinářem je zcela zásadní.
          Jedině tak může být separační úzkost správně diagnostikována.
        </p>
        <img src={DogPhotoShoot.src} alt="Dog being monitored " className="article-image" />
        <h5>Které osoby a zvířata jsou součástí domácnosti?</h5>
        <p>
          Nejvíc jsou separační úzkostí ohroženi psi, kteří žijí s jednou osobou. Významnou událostí může být ztráta
          dlouholetého kamaráda - jiného psa nebo kočky, na jejichž společnost byl pes zvyklý od štěněte. Pořízení
          nového psa jako náhradního společníka nemívá pozitivní efekt.
        </p>
        <h5>Jaký je vztah psa k jednotlivým osobám, které žijí v domácnosti?</h5>
        <p>
          Osoby, ke kterým má pes spíš vlažný vztah, nepostrádá tolik jako toho, koho považuje za nejdůležitějšího. A
          nemusí to vůbec být „hlava rodiny“ v našem lidském pojetí.
        </p>
        <h5>Vykazuje pes velkou závislost na jedné osobě?</h5>
        <p>
          Postižený pes je většinou stále „nalepený“ na toho, ke komu má patologicky nejsilnější vazbu. Takovému člověku
          se snaží ležet na nohách nebo vedle něj na gauči, chodí za ním po bytě, kamkoliv se pohne, nedokáže klidně
          odpočívat ve vedlejší místnosti a vyskočí při každém náznaku, že tento člověk odchází.
        </p>
        <h5>Jaký je denní režim domácnosti?</h5>
        <p>
          Ideální je pravidelnost a dodržování rituálů, které psa informují o tom, že je vše tak, jak má být.
          Nepravidelné pracovní směny, občasná večerní nepřítomnost majitele a služební cesty, kdy je pes dlouho sám
          nebo ho hlídají cizí osoby, bývají rizikové.
        </p>
        <h5>Jaký je režim krmení, vycházek, her a cvičení?</h5>
        <p>
          Všechny tyto informace jsou důležité hlavně proto, aby majitel mohl naplánovat vhodný tréninkový postup. Se
          psem, se kterým je majitel zvyklý pracovat a správně ho motivovat k učení nových prvků, je trénink samoty
          daleko jednodušší než se psem, který s majitelem nikdy necvičil.
        </p>
        <h5>Jak problémové chování vypadá?</h5>
        <p>
          Důležité jsou všechny detaily, zvlášť intenzita projevů úzkosti v čase - jak dlouho před odchodem majitele
          začne být pes nervózní, jak se to projevuje, kdy je jeho úzkostné chování nejsilnější, jestli příznaky
          postupně slábnou nebo jsou stejně intenzivní po celou dobu nepřítomnosti majitele a podobně.
        </p>
        <h5>Kdy se toto chování poprvé vyskytlo?</h5>
        <p>
          Někteří psi, které si majitelé pořídili jako odrostlá štěňata nebo adoptovali z útulku, vykazují úzkostné
          chování od prvních dnů, během kterých si na nového majitele vytvoří silnou vazbu. Často také separační úzkosti
          předchází delší přítomnost majitele doma (nemoc, mateřská dovolená, nezaměstnanost), nebo naopak jeho
          nepřítomnost (dovolená, dlouhá služební cesta, pobyt v nemocnici). Úzkost může vyvolat i odloučení od psa nebo
          kočky, s nimiž byl pes zvyklý zůstávat doma.
        </p>
        <h5>Za jakých podmínek k takovému chování dochází?</h5>
        <p>
          Je pes klidný, když je s ním doma jiná osoba, kterou zná? Toleruje alespoň krátké „rituální“ odchody,
          například na nákup (symbolizovaný nákupní taškou) nebo odchod s pytlem odpadků?
        </p>
        <h5>Jak reaguje majitel?</h5>
        <p>
          Napomíná psa nebo ho bije za zničené předměty či pomočené koberce? Zavírá psa do klece, uvazuje ho nebo mu
          dává elektrický protištěkací obojek?
        </p>
        <h5>Jak pes typicky vítá při návratu a jak na vítání reaguje majitel?</h5>
        <p>
          Je vítání hodně hektické a neobejde se bez skákání, kňučení a zrychleného dýchání? Chová se pes „provinile“,
          krčí se a snaží se schovat nebo si lehá na záda?
        </p>
        <h5>Jaké jsou zvyklosti před odchodem a jak na ně pes reaguje?</h5>
        <p>
          Při kterých činnostech, které předcházejí odchodu, začíná pes být nervózní? Reaguje na všechny odchody stejně,
          nebo na některé jinak – například večer, o víkendu a podobně? Je to jiné, než jak se chová během týdne?
          Reaguje pes jinak, když odcházejí členové rodiny postupně, a jinak, když odcházejí všichni najednou? Je při
          odchodu některých lidí pes docela klidný a odchod jiných snáší naopak těžce? Za jak dlouho po odchodu majitele
          začne pes vykazovat příznaky stresu? Pro separační úzkost je typické, že je pes neklidný už předem a největší
          stres vypukne hned nebo velmi brzy po jeho odchodu.
        </p>
        <h5>Kde je pes v době, kdy je majitel pryč?</h5>
        <p>
          Má pes k dispozici celý byt nebo dům, ve kterém se pohybuje, když je majitel doma? Nebo má omezený prostor?
          Jak reaguje, když je do tohoto prostoru zavírán?
        </p>
        <h5>Jak se pes chová, když je ponechán v jiném prostředí a s jinými lidmi?</h5>
        <p>Dokáže být pes klidný, když ho hlídají příbuzní nebo známí? Jí a pije? Odpočívá? Hraje si? Komunikuje?</p>
        <h5>Vychází pes dobře s jinými psy?</h5>
        <p>
          Tento údaj je důležitý pro případy, kdy pes během terapie tráví část dne v psím hotelu nebo v jiném zařízení,
          kde se pohybují i jiní psi.
        </p>
        <h5>Vykazuje pes nějaký další strach nebo fobii?</h5>
        <p>
          Nervově labilní psy, kteří trpí strachem z bouřky, střelby a podobných podnětů, často postihuje i separační
          úzkost. U těchto psů je léčba časově náročná a ne vždy se povede problém odstranit docela.
        </p>
        <div id="diagnostics" className="chapter-wrap">
          <div className="chapter-number">06 </div>
          <h3>Jak diagnostikovat separační úzkost?</h3>
        </div>
        <p>
          Když majitel psa přivede do veterinární ordinace, obvykle nevykazuje chování, podle kterého by lékař mohl
          stanovit diagnózu separační úzkosti. Vychází tedy především z anamnézy - údajů od majitele - která nemusí být
          perfektně přesná nebo úplná.
        </p>
        <p>
          Proto je ke stanovení správné diagnózy ideální videonahrávka, ze které je patrné chování psa v určitém časovém
          úseku. Podle příznaků, které pes na nahrávce vykazuje, pak veterinář určí diagnózu buď hned, nebo se zaměří na
          podrobnější vyšetření určitých systémů (močového, zažívacího, oběhového, nervového nebo kožního) pomocí
          laboratorních nebo zobrazovacích metod.
        </p>
        <p>Před zahájením léčby veterinář potřebuje dobře znát celkový zdravotní stav pacienta.</p>
        <a href="/">
          <img src={BarkioBanner2.src} alt="Barkio app" className="article-image banner" />
        </a>
        <div id="treatment" className="chapter-wrap">
          <div className="chapter-number">07 </div>
          <h3>Léčba</h3>
        </div>
        <h4>a) Pochopení podstaty problému</h4>
        <p>
          Nejdřív je potřeba přijmout fakt, že to pes nedělá naschvál a že se ani nemstí za to, že musel zůstat sám
          doma. Je prostě jen vyděšený a nedokáže se vyrovnat se samotou. Jakýkoliv trest, a to i výčitka nebo
          vyhubování, problém jenom zhorší, protože se potom pes bojí nejen samoty, ale i okamžiku, kdy se majitel
          vrátí. Ve chvíli, kdy pes vyje nebo ničí věci (popřípadě močí a kálí), si neuvědomuje žádné provinění. Jeho
          chování je jednoduše reakcí organismu na strach. Proto do léčení strachových poruch tresty v žádném případě
          nepatří! Samotná terapie může trvat dlouho, v některých případech i měsíce.
        </p>
        <p>
          Příznaky se mohou vrátit, když klient například odjede na několik dnů mimo dům, když je naopak stále doma a
          pak zase odejde do práce, při změně pracovní doby nebo při jakékoliv podobné změně v denním řádu domácnosti.
        </p>
        <div className="custom-quotation">
          <div className="custom-line col-lg-3"></div>
          <p>
            „Pes je prostě jen vyděšený a nedokáže se vyrovnat se samotou. Jakýkoliv trest, a to i výčitka nebo
            vyhubování, problém jenom zhorší, protože se pes potom bojí nejen samoty, ale i okamžiku, kdy se majitel
            vrátí.“
          </p>
        </div>
        <h4>b) Úprava podmínek a prostředí</h4>
        <p>
          Na prvním místě je vyloučení strachového podnětu. To znamená, že by během léčby pes neměl být vůbec ponechán o
          samotě. Buď by měl zůstat s majitelem, nebo na místě, kde se neprojevuje jeho úzkost (ve psím stacionáři či
          hotelu, u příbuzných, v autě, na zahradě). Pro lepší představu můžeme tento princip přirovnat k léčbě
          popáleniny: Nejdřív musíte ruku vytáhnout z ohně, pak se teprve může začít hojit.
        </p>
        <p>
          Prostředí by mělo být upraveno tak, aby bylo pro psa bezpečné (předejít možnosti útěků, úrazů a sebezraňování)
          a aby se v něm cítil dobře. Někteří psi mají kolem sebe rádi velký a přehledný prostor, jiní jsou klidnější v
          boxu či v kleci. Dále je důležitý každodenní trénink. Tomu (a později každému odchodu majitele) by měla
          předcházet procházka s hrami a cvičením, zakončená pochvalou a zklidněním. Před tréninkem (odchodem) by pes
          neměl dostávat jídlo.
        </p>
        <h4>c) Techniky modifikace chování</h4>
        <p>
          Jako u všech poruch spojených se strachem i při léčení separační úzkosti probíhá{" "}
          <span className="bold">desenzitizace</span> (velice krátké vystavení podnětu tak, aby nevyvolal strach, a
          postupné prodlužování doby expozice) a <span className="bold">kontrapodmiňování</span> (naučení nového
          podmíněného reflexu, nové odpovědi na stejný podnět). Podle charakteru a intenzity potíží majitel provádí buď
          všechna, nebo jen některá z následujících opatření:
        </p>
        <p>
          <span className="bold">Trénink nezávislosti:</span> Majitel nereaguje na loudění psa o pozornost, začíná a
          končí společné aktivity, odměňuje spontánní nezávislé chování (např. když je pes po nějakou dobu v pelíšku
          nebo v jiné místnosti), je od psa oddělen přepážkou - ale jen na tak dlouho, aby to u psa nevyvolalo stres.
        </p>
        <p>
          <span className="bold">Změna významu odchodových rituálů:</span> Majitel provádí obvyklé rituály (klíče,
          kabelka, oblečení, parfém atd.), jde směrem ke dveřím, ale neodejde a vrátí se k předchozí činnosti. To se
          opakuje 2x-3x denně, dokud pes nezůstane klidný. Pauza mezi cvičeními musí být tak dlouhá, aby se pes docela
          uklidnil. Cílem je, aby si tyto rituály přestal spojovat pouze s odchodem a s dlouhou nepřítomností majitele.
        </p>
        <img src={LeavingDog.src} alt="Leaving the Dog alone" className="article-image" />
        <p>
          <span className="bold">Změna odchodových a příchodových zvyklostí:</span> Majitel si psa nevšímá zhruba 5-15
          minut před odchodem, neloučí se. Při příchodu zvolí jen pozdrav bez emocí a hned vezme psa ven.
        </p>
        <div className="space-left">
          <div className="quoteline-side">
            <div className="custom-quotation2">
              <p>
                <span className="color-quote">Desenzitizace </span>je velice krátké vystavení podnětu tak, aby nevyvolal
                strach, a postupné prodlužování doby expozice.
              </p>

              <p>
                <span className="color-quote">Kontrapodmiňování </span>je naučení nového podmíněného reflexu, nové
                odpovědi na stejný podnět.
              </p>
            </div>
          </div>
        </div>
        <p>
          <span className="bold">Odchodové kontrapodmiňování:</span> Majitel naučí psa pobývat na místě, kde se nebojí a
          dokáže se uvolnit. Spojí cvičné náznaky odchodů a později krátké odchody s něčím příjemným, nejlépe s
          atraktivní potravou v plnicí hračce. Pokud pak musí majitel odejít na delší dobu, než je pes naučený, neměl by
          ho nechávat na místě, kde probíhají cvičné odchody, a neměl by mu dávat hračky, se kterými cvičí. Každý den by
          měl pes absolvovat 1-2 tréninky.
        </p>
        <p>
          Na začátku je určen čas, po který pes vydrží sám bez nervozity. Můžou to být sekundy nebo minuty. Po sekundách
          (minutách) se doba samoty prodlužuje. Odchody a příchody se odehrávají bez emocí a bez zájmu o psa. Před
          odchodem dá majitel psovi plnicí hračku. Když se pes zvedne a snaží se majitele následovat, ten se vrátí a
          hračku mu vezme. Ve cvičení se pokračuje, až se pes úplně uklidní a má o hračku opět velký zájem.
        </p>
        <p>
          Odchody jsou nejprve jen naznačené, případně může majitel odejít jen do vedlejší místnosti. Až když tyto
          náznaky odchodů pes dobře snáší, majitel zkusí otevřít dveře do chodby, vykročit a hned se zase vrátit. Příště
          za sebou zkusí zavřít dveře a hned je zas otevřít. Nakonec odchází z bytu na několik vteřin až minut a svou
          nepřítomnost prodlužuje po 1-2 minutách. Postupně se začíná chovat jako při skutečných odchodech - vezme si
          kabelku, boty, klíče a tak dále. Pokud je pes nervózní, je potřeba se vrátit na úroveň, kdy zůstává klidný.
        </p>
        <p>
          Jakmile pes vydrží sám v klidu cca 30 minut, dají se návraty prodlužovat po 5-10 minutách. Pokud vydrží sám
          2-3 hodiny, už není třeba cvičit dál. Pes by ale neměl zůstávat sám delší dobu, než je mu příjemné.
        </p>
        <div className="warning-box">
          <h6>POZOR!</h6>
          <ul>
            <li>
              <p className="warning-txt">
                <span className="bold">Nesprávně aplikovaná behaviorální terapie</span> může vést k většímu strachu.
                Pokud majitel pokračuje v nácviku odchodů a nepřítomnosti i přesto, že pes vykazuje nervozitu a strach,
                jeho stav se zhorší.
              </p>
            </li>

            <li>
              <p className="warning-txt">
                <span className="bold">Trénink v kleci nebo v boxu</span> je možné provádět jen se psy, kteří malé
                prostory vyhledávají a cítí se v nich dobře a bezpečně. U ostatních psů klec nebo jiný malý prostor
                projevy úzkosti často zhorší.
              </p>
            </li>

            <li>
              <p className="warning-txt">
                <span className="bold">Pořídit druhé zvíře</span> jako společníka se nedoporučuje, většinou se to
                neosvědčí.
              </p>
            </li>
          </ul>
        </div>
        <h4>d) Medikamenty</h4>
        <p>
          Lehčí formy separační úzkosti se dají zvládnout pečlivým cvičením bez nutnosti lékové terapie, lépe to však
          jde s pomocí přípravků, které tlumí strach a úzkost a zároveň jsou bezpečné a volně dostupné. Patří sem
          především preparáty, které obsahují <span className="bold">syntetické psí zklidňující feromony</span>,
          například odpařovače a obojky, a dále <span className="bold">doplňky stravy</span> s obsahem L-tryptofanu nebo
          alfa-kasozepinu, případně i kompletní veterinární diety obohacené právě o tyto látky.
        </p>
        <p>
          Farmakologická léčba je zaměřena na neurotransmitery (chemické přenašeče), které se účastní strachové a
          úzkostné reakce: serotonin, noradrenalin, dopamin, GABA. Tyto léky předepisuje veterinární lékař po důkladném
          vyšetření pacienta a pečlivě sleduje jejich účinnost, popřípadě nežádoucí vedlejší účinky.
        </p>
        <div id="patient-monitoring" className="chapter-wrap">
          <div className="chapter-number">08 </div>
          <h3>Monitorování pacienta</h3>
        </div>
        <p>
          Nejlepším způsobem, jak posoudit pokroky terapie, je sledovat psa v době, kdy je sám. To může být prováděno za
          pomoci kamery nebo{" "}
          <a
            id="psi-link-lecba"
            target="_blank"
            href="https://barkio.com/cs?utm_source=web_separacni_uzkosti&utm_medium=web_separacni_uzkosti&utm_campaign=web_separacni_uzkosti"
            className="DMlink"
          >
            Barkia
          </a>
          . Tato praktická mobilní aplikace dovoluje majiteli psa mít audio i vizuální přehled o tom, čím pes doma
          prochází. To umožní přizpůsobit trénink a veterinárnímu lékaři to dodává podklady k rozhodnutí, zda a kdy
          nasadit, vysadit nebo změnit farmakologickou léčbu. Léková terapie by u této poruchy totiž měla trvat ještě
          měsíc po dosažení úspěchu, potom se vysazuje zhruba 1⁄4 dávky za týden za současného pozorování, jestli se
          symptomy strachu neobjeví znovu.
        </p>
        <img src={DogMonitoring.src} alt="Leaving the Dog alone" className="article-image" />{" "}
        <div id="prevention" className="chapter-wrap">
          <div className="chapter-number">09 </div>
          <h3>Prevence</h3>
        </div>
        <p>
          Prevence spočívá v pomalém přivykání štěňat na samotu. Pro zvýšení úspěšnosti doporučujeme nechávat štěně v
          příjemném a bezpečném prostředí, před odchodem ho vyvenčit a zacvičit si a při odchodu mu nechat odměnu v
          podobě plnicí hračky. Loučení a vítání je vhodné omezit na krátký pozdrav.
        </p>
        <p>
          Chování štěněte o samotě je vhodné od začátku monitorovat, aby se délka samoty a vybavení prostředí daly
          přizpůsobit fyziologickým potřebám (příjem potravy, vyměšování) a naturelu štěněte (hračky, pelíšky). Zároveň
          to pomůže zachytit první příznaky případné nervozity a strachu a problém se tak začne řešit včas, což je pro
          úspěšnost terapie významné.
        </p>
        <img src={Infographic.src} alt="How to say goodbye to your dog" className="infographic" />
        <p>
          Zde se opravdu hodí zmiňované{" "}
          <a
            id="psi-link-prevence"
            className="DMlink"
            target="_blank"
            href="https://barkio.com/cs?utm_source=web_separacni_uzkosti&utm_medium=web_separacni_uzkosti&utm_campaign=web_separacni_uzkosti"
          >
            Barkio
          </a>
          . Ta majiteli umožňuje pozorovat, jak se pes chová, když je doma sám. Záznam aktivit ukazuje historii
          monitorování, a tím majiteli i veterináři pomáhá získat přehled o jeho chování během určitého časového úseku.
          To dále dává možnost určit, jestli zvíře skutečně trpí separační úzkostí.
        </p>
        <div className="custom-quotation">
          <div className="custom-line col-lg-3"></div>
          <p>
            „Zde se opravdu hodí zmiňované{" "}
            <a
              id="psi-link-prevence-quote"
              target="_blank"
              href="https://barkio.com/cs?utm_source=web_separacni_uzkosti&utm_medium=web_separacni_uzkosti&utm_campaign=web_separacni_uzkosti"
            >
              Barkio
            </a>
            . Ta majiteli umožňuje pozorovat, jak se pes chová, když je doma sám. Záznam aktivit ukazuje historii
            chování psa, a tím majiteli i veterináři pomáhá najít vzorce chování.“
          </p>
        </div>
        <div id="prognosis" className="chapter-wrap">
          <div className="chapter-number">10 </div>
          <h3>Prognóza</h3>
        </div>
        <p>
          <span className="bold">Separační úzkost je často dobře řešitelná</span> s nízkými dávkami léků nebo i bez
          lékové terapie, pokud majitel správně spolupracuje. Léky mohou proces výrazně urychlit a psovi značně ulevit
          od strachu a úzkosti. Jsou však i případy, které jsou zcela rezistentní na trénink i léčbu. To bývá hlavně u
          dlouhotrvajících neřešených (nebo nesprávně řešených) úzkostí nebo při výskytu souběžných behaviorálních
          poruch.
        </p>
        <div id="stories" className="chapter-wrap">
          <div className="chapter-number">11 </div>
          <h3>Příběhy</h3>
        </div>
        <p>
          Zde najdete skutečné příběhy psích pacientů, kteří trpěli separační úzkostí, a také popis, jakým způsobem byly
          jejich potíže pod vedením odborníka řešeny.
        </p>
        <div id="card1" className="story-card" onClick={dialog3.open}>
          <img src={TT1.src} alt="bibi thumbnail" className="card-image" />

          <div className="card-contents">
            <p className="card-heading">Bibi o samotě pojídala své výkaly</p>

            <p className="card-txt">
              <span className="card-break">Bibi byla sedmiměsíční fenka francouzského buldočka.</span> Žila v městském
              bytě se svými páníčky, kteří byli už v důchodovém věku a většinu času s ní bývali doma. Bibi byla moc
              šikovná a poslušná, naučila se spoustu triků a skvěle vycházela s vnoučaty. Majitelé s ní ale měli jeden
              problém: Jakmile zůstala sama doma, byť jen na deset minut, hned se vymočila a vykálela a své výkaly pak
              pojídala. Její samota netrvala nikdy dlouho, maximálně dvě hodiny.
            </p>

            <button
              className={cx(
                button({ variant: "outlined" }),
                css({
                  border: "none",
                  ml: "auto",
                  display: "block",
                  mb: "0.5rem"
                })
              )}
            >
              ZOBRAZIT
            </button>
          </div>
        </div>
        <div id="card2" className="story-card" onClick={dialog4.open}>
          <img src={TT2.src} alt="rocky thumbnail" className="card-image" />

          <div className="card-contents">
            <p className="card-heading">Rocky vyl a naříkal když byl sám</p>

            <p className="card-txt">
              <span className="card-break">Rocky je patnáctiměsíční čilý a veselý pejsek,</span> jen je jako každý
              teriér trochu uštěkaný. Jeho panička Monika si jej přivezla, když mu bylo devět týdnů. Pilně docházela do
              štěněcí školičky a pak i na cvičiště. Rockyho bavilo hlavně aportování míčku, a tak s ním Monika začala
              trénovat flyball. Plány jim překazil Moničin úraz. Při pádu na lyžích si ošklivě zlomila nohu a léčila se
              téměř dva měsíce. V té době se s Rockym velice sblížila, byli stále spolu doma, hráli si, odpočívali. Na
              krátké vycházky jej bral Moničin přítel nebo maminka.
            </p>

            <button
              className={cx(
                button({ variant: "outlined" }),
                css({
                  border: "none",
                  ml: "auto",
                  display: "block",
                  mb: "0.5rem"
                })
              )}
            >
              ZOBRAZIT
            </button>
          </div>
        </div>
        <p>
          {" "}
          <span className="bold">
            Má i váš pejsek podobný příběh? Pošlete nám jej na{" "}
            <a id="nas-email" href="mailto:support@tappytaps.com?Subject=Separation%20anxiety">
              support@tappytaps.com
            </a>{" "}
            a vybrané příspěvky získají{" "}
            <a
              id="psi-link-zadost"
              target="_blank"
              href="https://barkio.com/cs?utm_source=web_separacni_uzkosti&utm_medium=web_separacni_uzkosti&utm_campaign=web_separacni_uzkosti"
              className="DMlink"
            >
              {" "}
              nebo jinou aplikaci
            </a>{" "}
            zdarma.
          </span>
        </p>
        <div id="about-us" className="chapter-wrap">
          <div className="chapter-number">12 </div>
          <h3>O Nás</h3>
        </div>
        <h4 id="us">Tvůrci Psí Chůvičky</h4>
        <p>
          S aplikací{" "}
          <a
            id="psi-link-onas"
            className="DMlink"
            target="_blank"
            href="http://www.dogmonitorapp.com/cs/?utm_source=separation_anxiety_web_cz&utm_campaign=separation_anxiety_web_cz"
          >
            Psí Chůvička
          </a>{" "}
          přišli na popud uživatelů své obdobně fungující{" "}
          <a id="baby-link-onas" className="DMlink" target="_blank" href="https://www.babymonitor3g.com/cs/">
            Chůvičky 3G
          </a>
          , která monitoruje děti. Někteří uživatelé oslovili tvůrce s tím, že používají{" "}
          <a id="baby-link-onas-ii" className="DMlink" target="_blank" href="https://www.babymonitor3g.com/cs/">
            Chůvičku 3G
          </a>{" "}
          na monitorování svých psů a že jim pomáhá se separační úzkostí. Tvůrci tak vyvinuli i „psí verzi”. V roce 2020
          pak spustili{" "}
          <a
            id="psi-link-onas"
            className="DMlink"
            target="_blank"
            href="https://barkio.com/cs?utm_source=web_separacni_uzkosti&utm_medium=web_separacni_uzkosti&utm_campaign=web_separacni_uzkosti"
          >
            Barkio
          </a>
          , novou generaci aplikací pro monitoring psů.
        </p>
        <p>
          O problematiku separační úzkosti se začali intenzivně zajímat. Po poradách s desítkami veterinářů a psích
          psychologů, upravili aplikaci tak, aby efektivněji pomáhala s řešením tohoto problému. Ve spolupráci s
          odborníky v čele s MVDr. Žertvou ucelili veškeré znalosti o separační úzkosti do toho webu.
        </p>
        <h4 id="hana-zertova">MVDr. Hana Žertová</h4>
        <p>
          Vystudovala Vysokou školu veterinární v Brně. Pracovala v redakcích odborných veterinárních časopisů
          Veterinářství, Veterinární klinika a Zvěrokruh, později vydávala vlastní časopis Zvířata a zdraví. Dále
          pracovala v ordinaci pro malá zvířata.{" "}
        </p>
        <p>
          Posledních patnáct let se věnuje výhradně{" "}
          <a id="zertova-reseni" className="DMlink" href="http://www.hanazertova.cz/">
            řešení poruch chování psů a koček
          </a>
          . Znalosti v tomto oboru získala především v systému postgraduálního vzdělávání veterinárních lékařů v
          Německu. V roce 2009 natočila televizní seriál Polepšovna mazlíčků. Doktorka Žertová je také autorkou knihy „
          <a id="zertova-kniha" className="DMlink" href="http://www.hanazertova.cz/produkt/od-stenete-ke-psu/">
            Od štěněte ke psu
          </a>
          “ zabývající se správnou výchovou štěňat.
        </p>
        <h4 id="literature">Literatura</h4>
        <p>Při zpracování tématu jsme vycházeli převážně z následujících zdrojů:</p>
        <ul>
          <li>
            <p>
              <span className="bold">Schmidt W-D:</span> Verhaltenstherapie des Hundes. Schlütersche, Hannover, 2002.{" "}
            </p>
          </li>
          <li>
            <p>
              <span className="bold">Horwitz DF, Neilson JC:</span> Canine and Feline Bahavior. Blackwell Publishing,
              Ames 2007.
            </p>
          </li>
          <li>
            <p>
              <span className="bold">Bennet SL:</span> Animal Behavior Case of the Month. JAVMA 234, 12, 2013:
              1697-1699.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}
